"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAuthorizationContext = void 0;
var react_1 = require("react");
var AuthorizationContext_1 = require("../contexts/AuthorizationContext");
//This custom hook is responsible for consuming the AuthorizationContext.
function useAuthorizationContext() {
    var context = (0, react_1.useContext)(AuthorizationContext_1.AuthorizationContext);
    if (!context) {
        throw new Error('The useAuthorizationContext must be used within an AuthorizationProvider.');
    }
    return context;
}
exports.useAuthorizationContext = useAuthorizationContext;
//# sourceMappingURL=useAuthorizationContext.js.map